<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="!loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form id="familydetails_form" @submit.prevent="submit" v-model="isValid" v-if="loader">
      <v-row dense justify="center">
        <v-col cols="10" sm="10" md="10">
          <input type="hidden" :value="application_form_data.admission_form_id" name="admission_form_id" />

          <v-row dense justify="center" v-if="form_who_takes_pupil_studies != null">
            <v-col cols="10" sm="10" md="10">
              <v-icon color="error" v-if="form_who_takes_pupil_studies">*</v-icon>
              <v-text-field dense v-model.trim="who_takes_pupil_studies" name="who_takes_pupil_studies"
                :required="form_who_takes_pupil_studies" :rules="
                  form_who_takes_pupil_studies
                    ? [(v) => !!v || 'Please enter required data']
                    : []
                " :clearable="form_who_takes_pupil_studies ? false : true" :prepend-icon="
                  form_who_takes_pupil_studies != null
                    ? 'mdi-account-circle'
                    : 'mdi-account-circle-outline'
                " outlined hint="Members of the family who are able to supervise the pupil's studies at home"
                persistent-hint></v-text-field>
            </v-col>
          </v-row>

          <!--  Father Details --------------------------------------------->
        </v-col>
      </v-row>
      <v-row class="mb-3" v-if="show_single_parent_checkbox">
        <v-checkbox v-model="isSingleFather" @change="toggleParent('father')" label="Single Father ?" hide-details
          class="mr-4"></v-checkbox>
        <v-checkbox v-model="isSingleMother" @change="toggleParent('mother')" label="Single Mother ?"
          hide-details></v-checkbox>
      </v-row>
      <div v-if="!isSingleMother">
        <input v-if="relative_father_details" type="hidden" value="Father" name="relation_type" />
        <v-row dense justify="center" v-if="relative_father_details">
          <v-col cols="10" sm="10" md="10">
            <h4>*{{ relative_father_details.field_display_name }} [Please fill all available data]</h4>
          </v-col>
        </v-row>
        <v-row dense justify="center" v-if="relative_father_details">
          <v-col cols="10" sm="10" md="10">
            <v-icon color="error" v-if="form_relative_details.relative_full_name"
            >*</v-icon
          >
            <v-text-field dense v-model.trim="relative_father_details.relative_full_name" name="father_full_name"
              :required="form_relative_details.relative_full_name" 
              :rules="[
                v => !form_relative_details.relative_full_name || !!v || 'Father Name is required'
              ]"
              @input="convertToUnicode(relative_father_details.relative_full_name, father_name_local_lang)"
              :clearable="form_relative_details.relative_full_name ? false : true" :prepend-icon="
              relative_father_details.relative_full_name != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Enter as First Name Middle Name Last Name" persistent-hint></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="father_name_local_lang != null">
          <v-col cols="10" sm="10" md="10">
            <v-icon color="error" v-if="father_name_local_lang.required">*</v-icon>
            <v-text-field dense  v-model.trim="father_name_local_lang.field_value" :name="father_name_local_lang.field_name" :required="father_name_local_lang.required"
              :rules="
                father_name_local_lang.required
                  ? [v => !!v || father_name_local_lang.field_display_name + ' is required']
                  : []
              " :clearable="father_name_local_lang.required ? false : true" :prepend-icon="
                father_name_local_lang.field_value != null
                  ? 'mdi-account-circle'
                  : 'mdi-account-circle-outline'
              " outlined :hint=father_name_local_lang.field_display_name persistent-hint></v-text-field>
          </v-col>
        </v-row>
        
        <v-row dense justify="center" v-if="relative_father_details">
          <v-col cols="10" sm="10" md="10">
            <v-icon color="error" v-if="form_relative_details.relative_contact_no"
            >*</v-icon
          >
            <v-text-field dense type="text" v-model.trim="relative_father_details.relative_contact_no"
              name="father_contact_no" :required="form_relative_details.relative_contact_no" counter maxlength="10"
              hint="Mobile No."
              :rules="[
                v => !form_relative_details.relative_contact_no || !!v || 'Mobile No is required',
                v => !v || rules.mobile(v)
              ]"
              persistent-hint single-line outlined :clearable="
              form_relative_details.relative_contact_no ? false : true
            " :prepend-icon="
              relative_father_details.relative_contact_no != null
                ? 'mdi-phone-classic'
                : 'mdi-phone-classic'
            "></v-text-field>
          </v-col>
        </v-row>
        <v-row dense justify="center" v-if="relative_father_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon color="error" v-if="form_relative_details.relative_phone_no"
            >*</v-icon
          > -->
            <v-text-field dense type="number" v-model.trim="relative_father_details.relative_phone_no" name="father_phone_no"
              :required="form_relative_details.relative_phone_no" counter hint="Phone/Landline No." persistent-hint
              single-line outlined :clearable="
              form_relative_details.relative_phone_no ? false : true
            " :prepend-icon="
              relative_father_details.relative_phone_no != null
                ? 'mdi-phone-classic'
                : 'mdi-phone-classic'
            "></v-text-field>
          </v-col>
        </v-row>
        <v-row dense justify="center" v-if="relative_father_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon color="error" v-if="form_relative_details.relative_email"
            >*</v-icon
          > -->
            <v-text-field dense type="email" v-model.trim="relative_father_details.relative_email" name="father_email"
              :required="form_relative_details.relative_email" counter hint="Email" persistent-hint single-line outlined
              :clearable="form_relative_details.relative_email ? false : true" :prepend-icon="
              relative_father_details.relative_email != null
                ? 'mdi-email'
                : 'mdi-email'
            "></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="tenant == 'uwws'">
          <v-col cols="10" sm="10" md="10">
            <v-radio-group v-model="idTypeFather" row>
              <v-radio label="Aadhar No." value="aadhar"></v-radio>
              <v-radio label="Passport No." value="passport"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_father_details && tenant == 'uwws'">
          <v-col cols="10" sm="10" md="10">
            <v-text-field v-if="idTypeFather === 'aadhar'" dense v-model.trim="relative_father_details.relative_aadharno"
              name="father_aadharno" :required="form_relative_details.relative_aadharno"
              :clearable="form_relative_details.relative_aadharno ? false : true"
              :prepend-icon="relative_father_details.relative_aadharno ? 'mdi-account-circle' : 'mdi-account-circle-outline'"
              outlined hint="Aadhaar Card No." persistent-hint></v-text-field>

            <v-text-field v-if="idTypeFather === 'passport'" dense v-model.trim="relative_father_details.relative_passportno"
              name="father_passportno" :required="form_relative_details.relative_passportno"
              :clearable="form_relative_details.relative_passportno ? false : true"
              :prepend-icon="relative_father_details.relative_passportno ? 'mdi-passport' : 'mdi-passport-outline'"
              outlined hint="Passport No." persistent-hint></v-text-field>
          </v-col>
        </v-row>


        <v-row dense justify="center" v-if="relative_father_details && tenant != 'uwws'">
          <v-col cols="10" sm="10" md="10">
            <v-icon color="error" v-if="form_relative_details.relative_aadharno"
            >*</v-icon
          >
            <v-text-field dense v-model.trim="relative_father_details.relative_aadharno" name="father_aadharno"
              :required="form_relative_details.relative_aadharno"
              :clearable="form_relative_details.relative_aadharno ? false : true" :prepend-icon="
              relative_father_details.relative_aadharno != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Aadhaar Card No." persistent-hint></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_father_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon color="error" v-if="form_relative_details.relative_citizenship"
            >*</v-icon
          > -->
            <v-text-field dense v-model.trim="relative_father_details.relative_citizenship" name="father_citizenship"
              :required="form_relative_details.relative_citizenship"
              :clearable="form_relative_details.relative_citizenship ? false : true" :prepend-icon="
              relative_father_details.relative_citizenship != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Citizenship." persistent-hint></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_father_details">
          <v-col cols="10" sm="10" md="10">
            <v-autocomplete dense v-model="relative_father_details.relative_nationality" :items="nationality_list"
              name="father_nationality" :required="form_relative_details.relative_nationality" :clearable="
              form_relative_details.relative_nationality ? false : true
            " return-object single-line :prepend-icon="
              relative_father_details.relative_nationality != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            " outlined hint="Nationality" persistent-hint></v-autocomplete>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_father_details">
          <v-col cols="10" sm="10" md="10">
            <v-icon color="error" v-if="form_relative_details.relative_education"
            >*</v-icon
          >
            <v-text-field dense v-model.trim="relative_father_details.relative_education" name="father_education"
              :required="form_relative_details.relative_education" @input="convertToUnicode(relative_father_details.relative_education, father_education_qualification)"
              :clearable="form_relative_details.relative_education ? false : true" :prepend-icon="
              relative_father_details.relative_education != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Qualification" persistent-hint></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="father_education_qualification != null">
          <v-col cols="10" sm="10" md="10">
            <v-icon color="error" v-if="father_education_qualification.required">*</v-icon>
            <v-text-field dense  v-model.trim="father_education_qualification.field_value" :name="father_education_qualification.field_name" :required="father_education_qualification.required"
              :rules="
                father_education_qualification.required
                  ? [v => !!v || father_education_qualification.field_display_name + ' is required']
                  : []
              " :clearable="father_education_qualification.required ? false : true" :prepend-icon="
                father_education_qualification.field_value != null
                  ? 'mdi-book-education'
                  : 'mdi-book-education-outline'
              " outlined :hint=father_education_qualification.field_display_name persistent-hint></v-text-field>
          </v-col>
        </v-row>

        <!-- <v-row dense justify="center" v-if="relative_father_details.relative_occupation"> -->
          <v-row dense justify="center" v-if="relative_father_details && relative_father_details.relative_occupation">
          <v-col cols="10" sm="10" md="10">

          <v-icon color="error" v-if="relative_father_details.relative_occupation.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="relative_father_details.relative_occupation.field_value"
            :items="relative_father_details.relative_occupation.options"
            item-text ="name"
            item-value ="id"
            name="Father Occupation"
            :required="relative_father_details.relative_occupation.required"
            :clearable="relative_father_details.relative_occupation.required ? false : true"
            persistent-hint
            single-line
            hint="Father Occupation"
            prepend-icon="mdi-briefcase"
            outlined
          ></v-autocomplete> 
            <!-- <v-icon color="error" v-if="form_relative_details.relative_occupation"
            >*</v-icon
          > -->
            <!-- <v-text-field dense type="email" v-model.trim="relative_father_details.relative_occupation"
              name="father_occupation" :required="form_relative_details.relative_occupation" counter hint="Occupation"
              persistent-hint single-line outlined
              :prepend-icon="relative_father_details.relative_occupation != null? 'mdi-alpha-o-circle': 'mdi-alpha-o-circle-outline'"></v-text-field> -->



            <!-- <v-autocomplete
            dense
            v-model="relative_father_details.relative_occupation"
            :items="occupation_list"
            name="father_occupation"
            :required="form_relative_details.relative_occupation"
            :rules="
              form_relative_details.relative_occupation
                ? [(v) => !!v || ' Occupation is required']
                : []
            "
            :clearable="
              form_relative_details.relative_occupation ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_father_details.relative_occupation != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select Occupation"
            persistent-hint
          ></v-autocomplete> -->
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_father_details != null">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_designation"
            >*</v-icon
          > -->
            <v-text-field dense v-model.trim="relative_father_details.relative_designation" name="father_designation"
              :required="form_relative_details.relative_designation" :clearable="
              form_relative_details.relative_designation ? false : true
            " :prepend-icon="
              relative_father_details.relative_designation != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            " outlined hint="Designation" persistent-hint></v-text-field>
          </v-col>
        </v-row>
        <v-row dense justify="center" v-if="relative_father_details != null">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_organization_name"
            >*</v-icon
          > -->
            <v-text-field dense v-model.trim="relative_father_details.relative_organization_name"
              name="father_organization_name" :required="form_relative_details.relative_organization_name" :clearable="
              form_relative_details.relative_organization_name ? false : true
            " :prepend-icon="
              relative_father_details.relative_organization_name != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            " outlined hint="Company/Organization" persistent-hint></v-text-field>
          </v-col>
        </v-row>
        <v-row dense justify="center" v-if="relative_father_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_office_address"
            >*</v-icon
          > -->
            <v-textarea dense clear-icon="cancel" v-model.trim="relative_father_details.relative_office_address"
              :value="relative_father_details.relative_office_address" name="father_office_address"
              :required="form_relative_details.relative_office_address"
              hint="Company/Organization Address & Contact details" persistent-hint single-line outlined :clearable="
              form_relative_details.relative_office_address ? false : true
            " :prepend-icon="
              relative_father_details.relative_office_address != null
                ? 'mdi-home-circle'
                : 'mdi-home-circle-outline'
            "></v-textarea>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_father_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_local_address"
            >*</v-icon
          > -->
            <v-textarea dense clear-icon="cancel" v-model.trim="relative_father_details.relative_local_address"
              :value="relative_father_details.relative_local_address" name="father_local_address"
              :required="form_relative_details.relative_local_address" hint="Local Address" persistent-hint single-line
              outlined :clearable="
              form_relative_details.relative_local_address ? false : true
            " :prepend-icon="
              relative_father_details.relative_local_address != null
                ? 'mdi-home-circle'
                : 'mdi-home-circle-outline'
            "></v-textarea>
          </v-col>
        </v-row>
        <v-row dense justify="center" v-if="relative_father_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_permanent_address"
            >*</v-icon
          > -->
            <v-textarea dense clear-icon="cancel" v-model.trim="relative_father_details.relative_permanent_address"
              :value="relative_father_details.relative_permanent_address" name="father_permanent_address"
              :required="form_relative_details.relative_permanent_address" hint="Permanent Address" persistent-hint
              single-line outlined :clearable="
              form_relative_details.relative_permanent_address ? false : true
            " :prepend-icon="
              relative_father_details.relative_permanent_address != null
                ? 'mdi-home-circle'
                : 'mdi-home-circle-outline'
            "></v-textarea>
          </v-col>
        </v-row>

        <!-- <v-row dense justify="center" v-if="relative_father_details">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_state"
            >*</v-icon
          >
          <v-autocomplete
            dense
            v-model="relative_father_details.relative_state"
            :items="state_list"
            name="father_state"
            :required="form_relative_details.relative_state"
            :rules="
              form_relative_details.relative_state
                ? [(v) => !!v || ' State is required']
                : []
            "
            :clearable="
              form_relative_details.relative_state ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_father_details.relative_state != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select State"
            persistent-hint
          ></v-autocomplete>
        </v-col>
      </v-row>
       <v-row dense justify="center" v-if="relative_father_details">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_city"
            >*</v-icon
          >
          <v-autocomplete
            dense
            v-model="relative_father_details.relative_city"
            :items="cities_list"
            name="father_city"
            :required="form_relative_details.relative_city"
            :rules="
              form_relative_details.relative_city
                ? [(v) => !!v || ' City is required']
                : []
            "
            :clearable="
              form_relative_details.relative_city ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_father_details.relative_city != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select City"
            persistent-hint
          ></v-autocomplete>
        </v-col>
      </v-row> -->
        <v-row dense justify="center" v-if="relative_father_details != null && tenant != 'uwws'">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon color="error" v-if="form_relative_details.relative_income"
            >*</v-icon
          > -->
            <v-text-field dense v-model.trim="relative_father_details.relative_income" name="father_income" type="number"
              :required="form_relative_details.relative_income"
              :clearable="form_relative_details.relative_income ? false : true" :prepend-icon="
              relative_father_details.relative_income != null
                ? 'mdi-alpha-c-circle'
                : 'mdi-alpha-c-circle-outline'
            " outlined hint="Annual Income" persistent-hint></v-text-field> </v-col></v-row>

        <!-- <v-row dense justify="center" v-if="relative_father_details != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_department"
            >*</v-icon
          >
          <v-text-field
            dense
            v-model="relative_father_details.relative_department"
            name="father_department"
            :required="form_relative_details.relative_department"
            :rules="
              form_relative_details.relative_department
                ? [(v) => !!v || 'Department is required']
                : []
            "
            :clearable="
              form_relative_details.relative_department ? false : true
            "
            :prepend-icon="
              relative_father_details.relative_department != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            "
            outlined
            hint="Department"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row> -->


        <hr color="grey lighten-1" v-if="relative_mother_details" />
      </div>
      <!-- End Father Details --------------------------------------------->

      <!-- Mother Details --------------------------------------------->

      <!-- show_single_parent_checkbox - {{ show_single_parent_checkbox }} -->
      <div v-if="!isSingleFather">
        <input v-if="relative_mother_details" type="hidden" value="Mother" name="relation_type" />

        <v-row dense justify="center" v-if="relative_mother_details">
          <v-col cols="10" sm="10" md="10">
            <h4>*{{ relative_mother_details.field_display_name }} [Please fill all available data]</h4>
          </v-col>
        </v-row>
        <v-row dense justify="center" v-if="relative_mother_details">
          <v-col cols="10" sm="10" md="10">
            <v-icon color="error" v-if="form_relative_details.relative_full_name"
            >*</v-icon
          >
            <v-text-field dense v-model.trim="relative_mother_details.relative_full_name" name="mother_full_name"
              :required="form_relative_details.relative_full_name" 
              :rules="[
                v => !form_relative_details.relative_full_name || !!v || 'Mother Name is required'
              ]"
              @input="convertToUnicode(relative_mother_details.relative_full_name, mother_name_local_lang)"
              :clearable="form_relative_details.relative_full_name ? false : true" :prepend-icon="
              relative_mother_details.relative_full_name != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Enter as First Name Middle Name Last Name" persistent-hint></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="mother_name_local_lang != null">
          <v-col cols="10" sm="10" md="10">
            <v-icon color="error" v-if="mother_name_local_lang.required">*</v-icon>
            <v-text-field dense  v-model.trim="mother_name_local_lang.field_value" :name="mother_name_local_lang.field_name" :required="mother_name_local_lang.required"
              :rules="
                mother_name_local_lang.required
                  ? [v => !!v || mother_name_local_lang.field_display_name + ' is required']
                  : []
              " :clearable="mother_name_local_lang.required ? false : true" :prepend-icon="
                mother_name_local_lang.field_value != null
                  ? 'mdi-account-circle'
                  : 'mdi-account-circle-outline'
              " outlined :hint=mother_name_local_lang.field_display_name persistent-hint></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_mother_details">
          <v-col cols="10" sm="10" md="10">
            <v-icon color="error" v-if="form_relative_details.relative_contact_no"
            >*</v-icon
          >
            <v-text-field dense type="text" v-model.trim="relative_mother_details.relative_contact_no"
              name="mother_contact_no" 
              :rules="[
                v => !form_relative_details.relative_contact_no || !!v || 'Mobile No is required',
                v => !v || rules.mobile(v)
              ]"
              :required="form_relative_details.relative_contact_no" counter maxlength="10"
              hint="Mobile No." persistent-hint single-line outlined :clearable="
              form_relative_details.relative_contact_no ? false : true
            " :prepend-icon="
              relative_mother_details.relative_contact_no != null
                ? 'mdi-phone-classic'
                : 'mdi-phone-classic'
            "></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_mother_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon color="error" v-if="form_relative_details.relative_phone_no"
            >*</v-icon
          > -->
            <v-text-field dense type="number" v-model.trim="relative_mother_details.relative_phone_no" name="mother_phone_no"
              :required="form_relative_details.relative_phone_no" counter hint="Phone /Landline No." persistent-hint
              single-line outlined :clearable="
              form_relative_details.relative_phone_no ? false : true
            " :prepend-icon="
              relative_mother_details.relative_phone_no != null
                ? 'mdi-phone-classic'
                : 'mdi-phone-classic'
            "></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_mother_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon color="error" v-if="form_relative_details.relative_email"
            >*</v-icon
          > -->
            <v-text-field dense type="email" v-model.trim="relative_mother_details.relative_email" name="mother_email"
              :required="form_relative_details.relative_email" counter hint="Email" persistent-hint single-line outlined
              :clearable="form_relative_details.relative_email ? false : true" :prepend-icon="
              relative_mother_details.relative_email != null
                ? 'mdi-email'
                : 'mdi-email'
            "></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="tenant == 'uwws'">
          <v-col cols="10" sm="10" md="10">
            <v-radio-group v-model="idTypeMother" row>
              <v-radio label="Aadhar No." value="aadhar"></v-radio>
              <v-radio label="Passport No." value="passport"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_mother_details && tenant == 'uwws'">
          <v-col cols="10" sm="10" md="10">
            <v-text-field v-if="idTypeMother === 'aadhar'" dense v-model.trim="relative_mother_details.relative_aadharno"
              name="mother_aadharno" :required="form_relative_details.relative_aadharno"
              :clearable="form_relative_details.relative_aadharno ? false : true"
              :prepend-icon="relative_mother_details.relative_aadharno ? 'mdi-account-circle' : 'mdi-account-circle-outline'"
              outlined hint="Aadhaar Card No." persistent-hint></v-text-field>

            <v-text-field v-if="idTypeMother === 'passport'" dense v-model.trim="relative_mother_details.relative_passportno"
              name="mother_passportno" :required="form_relative_details.relative_passportno"
              :clearable="form_relative_details.relative_passportno ? false : true"
              :prepend-icon="relative_mother_details.relative_passportno ? 'mdi-passport' : 'mdi-passport-outline'"
              outlined hint="Passport No." persistent-hint></v-text-field>
          </v-col>
        </v-row>


        <v-row dense justify="center" v-if="relative_mother_details && tenant != 'uwws'">
          <v-col cols="10" sm="10" md="10">
              <v-icon color="error" v-if="form_relative_details.relative_aadharno"
            >*</v-icon
          >
            <v-text-field dense v-model.trim="relative_mother_details.relative_aadharno" name="mother_aadharno"
              :required="form_relative_details.relative_aadharno"
              :clearable="form_relative_details.relative_aadharno ? false : true" :prepend-icon="
              relative_mother_details.relative_aadharno != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Aadhaar Card No." persistent-hint></v-text-field>
          </v-col>
        </v-row>
        <v-row dense justify="center" v-if="relative_mother_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon color="error" v-if="form_relative_details.relative_citizenship"
            >*</v-icon
          > -->
            <v-text-field dense v-model.trim="relative_mother_details.relative_citizenship" name="mother_citizenship"
              :required="form_relative_details.relative_citizenship"
              :clearable="form_relative_details.relative_citizenship ? false : true" :prepend-icon="
              relative_mother_details.relative_citizenship != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Citizenship." persistent-hint></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_mother_details">
          <v-col cols="10" sm="10" md="10">
            
            <v-autocomplete dense v-model="relative_mother_details.relative_nationality" :items="nationality_list"
              name="mother_nationality" :required="form_relative_details.relative_nationality" :clearable="
              form_relative_details.relative_nationality ? false : true
            " return-object single-line :prepend-icon="
              relative_mother_details.relative_nationality != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            " outlined hint="Nationality" persistent-hint></v-autocomplete>
          </v-col>
        </v-row>



        <v-row dense justify="center" v-if="relative_mother_details">
          <v-col cols="10" sm="10" md="10">
            <v-icon color="error" v-if="form_relative_details.relative_education"
            >*</v-icon
          >
            <v-text-field dense v-model.trim="relative_mother_details.relative_education" name="mother_education"
              :required="form_relative_details.relative_education" @input="convertToUnicode(relative_mother_details.relative_education, mother_education_qualification)"
              :clearable="form_relative_details.relative_education ? false : true" :prepend-icon="
              relative_mother_details.relative_education != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Qualification" persistent-hint></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="mother_education_qualification != null">
          <v-col cols="10" sm="10" md="10">
            <v-icon color="error" v-if="mother_education_qualification.required">*</v-icon>
            <v-text-field dense  v-model.trim="mother_education_qualification.field_value" :name="mother_education_qualification.field_name" :required="mother_education_qualification.required"
              :rules="
                mother_education_qualification.required
                  ? [v => !!v || mother_education_qualification.field_display_name + ' is required']
                  : []
              " :clearable="mother_education_qualification.required ? false : true" :prepend-icon="
                mother_education_qualification.field_value != null
                  ? 'mdi-book-education'
                  : 'mdi-book-education-outline'
              " outlined :hint=mother_education_qualification.field_display_name persistent-hint></v-text-field>
          </v-col>
        </v-row>


        <!-- <v-row dense justify="center" v-if="relative_mother_details.relative_occupation"> -->
          <v-row dense justify="center" v-if="relative_mother_details && relative_mother_details.relative_occupation">
          <v-col cols="10" sm="10" md="10">
            <v-autocomplete
            dense
            v-model="relative_mother_details.relative_occupation.field_value"
            :items="relative_mother_details.relative_occupation.options"
            item-text ="name"
            item-value ="id"
            name="Mother Occupation"
            :required="relative_mother_details.relative_occupation.required"
            :clearable="relative_mother_details.relative_occupation.required ? false : true"
            persistent-hint
            single-line
            hint="Mother Occupation"
            prepend-icon="mdi-briefcase"
            outlined
          ></v-autocomplete> 
            <!-- <v-icon color="error" v-if="form_relative_details.relative_occupation"
            >*</v-icon
          > -->
            <!-- <v-text-field dense type="email" v-model.trim="relative_mother_details.relative_occupation"
              name="mother_occupation" :required="form_relative_details.relative_occupation" counter hint="Occupation"
              persistent-hint single-line outlined
              :prepend-icon="relative_mother_details.relative_occupation != null? 'mdi-alpha-o-circle': 'mdi-alpha-o-circle-outline'"></v-text-field> -->



            <!-- <v-autocomplete
            dense
            v-model="relative_mother_details.relative_occupation"
            :items="occupation_list"
            name="mother_occupation"
            :required="form_relative_details.relative_occupation"
            :rules="
              form_relative_details.relative_occupation
                ? [(v) => !!v || ' Occupation is required']
                : []
            "
            :clearable="
              form_relative_details.relative_occupation ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_mother_details.relative_occupation != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select Occupation"
            persistent-hint
          ></v-autocomplete> -->
          </v-col>
        </v-row>
        <v-row dense justify="center" v-if="relative_mother_details != null">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_designation"
            >*</v-icon
          > -->
            <v-text-field dense v-model="relative_mother_details.relative_designation" name="mother_designation"
              :required="form_relative_details.relative_designation" :clearable="
              form_relative_details.relative_designation ? false : true
            " :prepend-icon="
              relative_mother_details.relative_designation != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            " outlined hint="Designation" persistent-hint></v-text-field>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_mother_details != null">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_organization_name"
            >*</v-icon
          > -->
            <v-text-field dense v-model.trim="relative_mother_details.relative_organization_name"
              name="mother_organization_name" :required="form_relative_details.relative_organization_name" :clearable="
              form_relative_details.relative_organization_name ? false : true
            " :prepend-icon="
              relative_mother_details.relative_organization_name != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            " outlined hint="Company/Organization" persistent-hint></v-text-field>
          </v-col>
        </v-row>
        <v-row dense justify="center" v-if="relative_mother_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_office_address"
            >*</v-icon
          > -->
            <v-textarea dense clear-icon="cancel" v-model.trim="relative_mother_details.relative_office_address"
              :value="relative_mother_details.relative_office_address" name="mother_office_address"
              :required="form_relative_details.relative_office_address"
              hint="Company/Organization Address & Contact details" persistent-hint single-line outlined :clearable="
              form_relative_details.relative_office_address ? false : true
            " :prepend-icon="
              relative_mother_details.relative_office_address != null
                ? 'mdi-home-circle'
                : 'mdi-home-circle-outline'
            "></v-textarea>
          </v-col>
        </v-row>

        <v-row dense justify="center" v-if="relative_mother_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_local_address"
            >*</v-icon
          > -->
            <v-textarea dense clear-icon="cancel" v-model.trim="relative_mother_details.relative_local_address"
              :value="relative_mother_details.relative_local_address" name="mother_local_address"
              :required="form_relative_details.relative_local_address" hint="Local Address" persistent-hint single-line
              outlined :clearable="
              form_relative_details.relative_local_address ? false : true
            " :prepend-icon="
              relative_mother_details.relative_local_address != null
                ? 'mdi-home-circle'
                : 'mdi-home-circle-outline'
            "></v-textarea>
          </v-col>
        </v-row>
        <v-row dense justify="center" v-if="relative_mother_details">
          <v-col cols="10" sm="10" md="10">
            <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_permanent_address"
            >*</v-icon
          > -->
            <v-textarea dense clear-icon="cancel" v-model.trim="relative_mother_details.relative_permanent_address"
              :value="relative_mother_details.relative_permanent_address" name="mother_permanent_address"
              :required="form_relative_details.relative_permanent_address" hint="Permanent Address" persistent-hint
              single-line outlined :clearable="
              form_relative_details.relative_permanent_address ? false : true
            " :prepend-icon="
              relative_mother_details.relative_permanent_address != null
                ? 'mdi-home-circle'
                : 'mdi-home-circle-outline'
            "></v-textarea>
          </v-col>
        </v-row>
      </div>

      <!-- ------ -->
      <!-- <v-row dense justify="center" v-if="relative_mother_details">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_state"
            >*</v-icon
          >
          <v-autocomplete
            dense
            v-model="relative_mother_details.relative_state"
            :items="state_list"
            name="mother_state"
            :required="form_relative_details.relative_state"
            :rules="
              form_relative_details.relative_state
                ? [(v) => !!v || ' State is required']
                : []
            "
            :clearable="
              form_relative_details.relative_state ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_mother_details.relative_state != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select State"
            persistent-hint
          ></v-autocomplete>
        </v-col>
      </v-row>
       <v-row dense justify="center" v-if="relative_mother_details">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_city"
            >*</v-icon
          >
          <v-autocomplete
            dense
            v-model="relative_mother_details.relative_city"
            :items="cities_list"
            name="mother_city"
            :required="form_relative_details.relative_city"
            :rules="
              form_relative_details.relative_city
                ? [(v) => !!v || ' City is required']
                : []
            "
            :clearable="
              form_relative_details.relative_city ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_mother_details.relative_city != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select City"
            persistent-hint
          ></v-autocomplete>
        </v-col>
      </v-row> -->
      <v-row dense justify="center" v-if="relative_mother_details != null && tenant != 'uwws'">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_income"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_mother_details.relative_income" name="mother_income" type="number"
            :required="form_relative_details.relative_income"
            :clearable="form_relative_details.relative_income ? false : true" :prepend-icon="
              relative_mother_details.relative_income != null
                ? 'mdi-alpha-c-circle'
                : 'mdi-alpha-c-circle-outline'
            " outlined hint="Annual Income" persistent-hint></v-text-field> </v-col></v-row>

      <!-- <v-row dense justify="center" v-if="relative_mother_details != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_department"
            >*</v-icon
          >
          <v-text-field
            dense
            v-model="relative_mother_details.relative_department"
            name="mother_department"
            :required="form_relative_details.relative_department"
            :rules="
              form_relative_details.relative_department
                ? [(v) => !!v || 'Department is required']
                : []
            "
            :clearable="
              form_relative_details.relative_department ? false : true
            "
            :prepend-icon="
              relative_mother_details.relative_department != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            "
            outlined
            hint="Department"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row> -->


      <hr color="grey lighten-1" v-if="relative_brother_details" />
      <!-- End Mother Details --------------------------------------------->

      <!-- Brother Details --------------------------------------------->
      <input v-if="relative_brother_details" type="hidden" value="Brother" name="relation_type" />
      <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <h4>{{ relative_brother_details.field_display_name }}</h4>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_full_name"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_brother_details.relative_full_name" name="brother_full_name"
            :required="form_relative_details.relative_full_name"
            :clearable="form_relative_details.relative_full_name ? false : true" :prepend-icon="
              relative_brother_details.relative_full_name != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Brother Full Name" persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_aadharno"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_brother_details.relative_aadharno" name="brother_aadharno"
            :required="form_relative_details.relative_aadharno"
            :clearable="form_relative_details.relative_aadharno ? false : true" :prepend-icon="
              relative_brother_details.relative_aadharno != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Brother Aadhaar No." persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_citizenship"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_brother_details.relative_citizenship" name="brother_citizenship"
            :required="form_relative_details.relative_citizenship"
            :clearable="form_relative_details.relative_citizenship ? false : true" :prepend-icon="
              relative_brother_details.relative_citizenship != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Brother Citizenship" persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_education"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_brother_details.relative_education" name="brother_education"
            :required="form_relative_details.relative_education"
            :clearable="form_relative_details.relative_education ? false : true" :prepend-icon="
              relative_brother_details.relative_education != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Education Details" persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_contact_no"
            >*</v-icon
          > -->
          <v-text-field dense type="text" v-model.trim="relative_brother_details.relative_contact_no"
            name="brother_contact_no" :rules="[rules.mobile]" :required="form_relative_details.relative_contact_no" counter maxlength="10"
            hint="Mobile no." persistent-hint single-line outlined :clearable="
              form_relative_details.relative_contact_no ? false : true
            " :prepend-icon="
              relative_brother_details.relative_contact_no != null
                ? 'mdi-phone-classic'
                : 'mdi-phone-classic'
            "></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_email"
            >*</v-icon
          > -->
          <v-text-field dense type="email" v-model.trim="relative_brother_details.relative_email" name="brother_email"
            :required="form_relative_details.relative_email" counter hint="Email" persistent-hint single-line outlined
            :clearable="form_relative_details.relative_email ? false : true" :prepend-icon="
              relative_brother_details.relative_email != null
                ? 'mdi-contact-mail'
                : 'mdi-contact-mail-outline'
            "></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_occupation"
            >*</v-icon
          > -->
          <v-text-field dense type="email" v-model.trim="relative_brother_details.relative_occupation"
            name="brother_occupation" :required="form_relative_details.relative_occupation" counter hint="Occupation"
            persistent-hint single-line outlined
            :prepend-icon="relative_brother_details.relative_occupation != null? 'mdi-alpha-o-circle': 'mdi-alpha-o-circle-outline'"></v-text-field>


          <!-- <v-autocomplete
            dense
            v-model="relative_brother_details.relative_occupation"
            :items="occupation_list"
            name="brother_occupation"
            :required="form_relative_details.relative_occupation"
            :rules="
              form_relative_details.relative_occupation
                ? [(v) => !!v || ' Occupation is required']
                : []
            "
            :clearable="
              form_relative_details.relative_occupation ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_brother_details.relative_occupation != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select Occupation"
            persistent-hint
          ></v-autocomplete> -->
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_nationality"
            >*</v-icon
          > -->
          <v-autocomplete dense v-model.trim="relative_brother_details.relative_nationality" :items="nationality_list"
            name="brother_nationality" :required="form_relative_details.relative_nationality" :clearable="
              form_relative_details.relative_nationality ? false : true
            " return-object single-line :prepend-icon="
              relative_brother_details.relative_nationality != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            " outlined hint="Select Nationality" persistent-hint></v-autocomplete>
        </v-col>
      </v-row>
      <!-- <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_state"
            >*</v-icon
          >
          <v-autocomplete
            dense
            v-model="relative_brother_details.relative_state"
            :items="state_list"
            name="brother_state"
            :required="form_relative_details.relative_state"
            :rules="
              form_relative_details.relative_state
                ? [(v) => !!v || ' State is required']
                : []
            "
            :clearable="
              form_relative_details.relative_state ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_brother_details.relative_state != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select State"
            persistent-hint
          ></v-autocomplete>
        </v-col>
      </v-row>
       <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_city"
            >*</v-icon
          >
          <v-autocomplete
            dense
            v-model="relative_brother_details.relative_city"
            :items="cities_list"
            name="brother_city"
            :required="form_relative_details.relative_city"
            :rules="
              form_relative_details.relative_city
                ? [(v) => !!v || ' City is required']
                : []
            "
            :clearable="
              form_relative_details.relative_city ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_brother_details.relative_city != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select City"
            persistent-hint
          ></v-autocomplete>
        </v-col>
      </v-row> -->

      <v-row dense justify="center" v-if="relative_brother_details != null">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_income"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_brother_details.relative_income" name="brother_income" type="number"
            :required="form_relative_details.relative_income"
            :clearable="form_relative_details.relative_income ? false : true" :prepend-icon="
              relative_brother_details.relative_income != null
                ? 'mdi-alpha-c-circle'
                : 'mdi-alpha-c-circle-outline'
            " outlined hint="Annual Income for example 800000" persistent-hint></v-text-field> </v-col></v-row>

      <v-row dense justify="center" v-if="relative_brother_details != null">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_organization_name"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_brother_details.relative_organization_name"
            name="brother_organization_name" :required="form_relative_details.relative_organization_name" :clearable="
              form_relative_details.relative_organization_name ? false : true
            " :prepend-icon="
              relative_brother_details.relative_organization_name != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            " outlined hint="Working Organization name" persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="relative_brother_details != null">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_designation"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_brother_details.relative_designation" name="brother_designation"
            :required="form_relative_details.relative_designation" :clearable="
              form_relative_details.relative_designation ? false : true
            " :prepend-icon="
              relative_brother_details.relative_designation != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            " outlined hint="Designation" persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <!-- <v-row dense justify="center" v-if="relative_brother_details != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_department"
            >*</v-icon
          >
          <v-text-field
            dense
            v-model="relative_brother_details.relative_department"
            name="brother_department"
            :required="form_relative_details.relative_department"
            :rules="
              form_relative_details.relative_department
                ? [(v) => !!v || 'Department is required']
                : []
            "
            :clearable="
              form_relative_details.relative_department ? false : true
            "
            :prepend-icon="
              relative_brother_details.relative_department != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            "
            outlined
            hint="Department"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row> -->

      <v-row dense justify="center" v-if="relative_brother_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_office_address"
            >*</v-icon
          > -->
          <v-textarea dense clear-icon="cancel" v-model.trim="relative_brother_details.relative_office_address"
            :value="relative_brother_details.relative_office_address" name="brother_office_address"
            :required="form_relative_details.relative_office_address" hint="Office Address" persistent-hint single-line
            outlined :clearable="
              form_relative_details.relative_office_address ? false : true
            " :prepend-icon="
              relative_brother_details.relative_office_address != null
                ? 'mdi-home-circle'
                : 'mdi-home-circle-outline'
            "></v-textarea>
        </v-col>
      </v-row>
      <hr color="grey lighten-1" v-if="relative_sister_details" />
      <!-- End of brother Details --------------------------------------------->

      <!-- Sister Details --------------------------------------------->
      <input v-if="relative_sister_details" type="hidden" value="Sister" name="relation_type" />
      <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <h4>{{ relative_sister_details.field_display_name }}</h4>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_full_name"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_sister_details.relative_full_name" name="sister_full_name"
            :required="form_relative_details.relative_full_name"
            :clearable="form_relative_details.relative_full_name ? false : true" :prepend-icon="
              relative_sister_details.relative_full_name != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Sister Full Name" persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_aadharno"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_sister_details.relative_aadharno" name="sister_aadharno"
            :required="form_relative_details.relative_aadharno"
            :clearable="form_relative_details.relative_aadharno ? false : true" :prepend-icon="
              relative_sister_details.relative_aadharno != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Sister aadharno" persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_citizenship"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_sister_details.relative_citizenship" name="sister_citizenship"
            :required="form_relative_details.relative_citizenship"
            :clearable="form_relative_details.relative_citizenship ? false : true" :prepend-icon="
              relative_sister_details.relative_citizenship != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Sister Citizenship" persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_education"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_sister_details.relative_education" name="sister_education"
            :required="form_relative_details.relative_education"
            :clearable="form_relative_details.relative_education ? false : true" :prepend-icon="
              relative_sister_details.relative_education != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Education Details" persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_contact_no"
            >*</v-icon
          > -->
          <v-text-field dense type="text" v-model.trim="relative_sister_details.relative_contact_no"
            name="sister_contact_no" :rules="[rules.mobile]" :required="form_relative_details.relative_contact_no" counter maxlength="10"
            hint="Mobile no." persistent-hint single-line outlined :clearable="
              form_relative_details.relative_contact_no ? false : true
            " :prepend-icon="
              relative_sister_details.relative_contact_no != null
                ? 'mdi-phone-classic'
                : 'mdi-phone-classic'
            "></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_email"
            >*</v-icon
          > -->
          <v-text-field dense type="email" v-model.trim="relative_sister_details.relative_email" name="sister_email"
            :required="form_relative_details.relative_email" counter hint="Email" persistent-hint single-line outlined
            :clearable="form_relative_details.relative_email ? false : true" :prepend-icon="
              relative_sister_details.relative_email != null
                ? 'mdi-contact-mail'
                : 'mdi-contact-mail-outline'
            "></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_occupation"
            >*</v-icon
          > -->
          <v-text-field dense type="email" v-model.trim="relative_sister_details.relative_occupation"
            name="sister_occupation" :required="form_relative_details.relative_occupation" counter
            hint="Select Occupation" persistent-hint single-line outlined
            :prepend-icon="relative_sister_details.relative_occupation != null? 'mdi-alpha-o-circle': 'mdi-alpha-o-circle-outline'"></v-text-field>



          <!-- <v-autocomplete
            dense
            v-model="relative_sister_details.relative_occupation"
            :items="occupation_list"
            name="sister_occupation"
            :required="form_relative_details.relative_occupation"
            :rules="
              form_relative_details.relative_occupation
                ? [(v) => !!v || ' Occupation is required']
                : []
            "
            :clearable="
              form_relative_details.relative_occupation ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_sister_details.relative_occupation != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select Occupation"
            persistent-hint
          ></v-autocomplete> -->
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_nationality"
            >*</v-icon
          > -->
          <v-autocomplete dense v-model="relative_sister_details.relative_nationality" :items="nationality_list"
            name="sister_nationality" :required="form_relative_details.relative_nationality" :clearable="
              form_relative_details.relative_nationality ? false : true
            " return-object single-line :prepend-icon="
              relative_sister_details.relative_nationality != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            " outlined hint="Select Nationality" persistent-hint></v-autocomplete>
        </v-col>
      </v-row>
      <!-- <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_state"
            >*</v-icon
          >
          <v-autocomplete
            dense
            v-model="relative_sister_details.relative_state"
            :items="state_list"
            name="sister_state"
            :required="form_relative_details.relative_state"
            :rules="
              form_relative_details.relative_state
                ? [(v) => !!v || ' State is required']
                : []
            "
            :clearable="
              form_relative_details.relative_state ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_sister_details.relative_state != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select State"
            persistent-hint
          ></v-autocomplete>
        </v-col>
      </v-row>
       <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_city"
            >*</v-icon
          >
          <v-autocomplete
            dense
            v-model="relative_sister_details.relative_city"
            :items="cities_list"
            name="sister_city"
            :required="form_relative_details.relative_city"
            :rules="
              form_relative_details.relative_city
                ? [(v) => !!v || ' City is required']
                : []
            "
            :clearable="
              form_relative_details.relative_city ? false : true
            "
            return-object
            single-line
            :prepend-icon="
              relative_sister_details.relative_city != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="Select City"
            persistent-hint
          ></v-autocomplete>
        </v-col>
      </v-row> -->


      <v-row dense justify="center" v-if="relative_sister_details != null">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error" v-if="form_relative_details.relative_income"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_sister_details.relative_income" name="sister_income" type="number"
            :required="form_relative_details.relative_income"
            :clearable="form_relative_details.relative_income ? false : true" :prepend-icon="
              relative_sister_details.relative_income != null
                ? 'mdi-alpha-c-circle'
                : 'mdi-alpha-c-circle-outline'
            " outlined hint="Annual Income for example 800000" persistent-hint></v-text-field> </v-col></v-row>

      <v-row dense justify="center" v-if="relative_sister_details != null">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_organization_name"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_sister_details.relative_organization_name"
            name="sister_organization_name" :required="form_relative_details.relative_organization_name" :clearable="
              form_relative_details.relative_organization_name ? false : true
            " :prepend-icon="
              relative_sister_details.relative_organization_name != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            " outlined hint="Working Organization name" persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="relative_sister_details != null">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_designation"
            >*</v-icon
          > -->
          <v-text-field dense v-model.trim="relative_sister_details.relative_designation" name="sister_designation"
            :required="form_relative_details.relative_designation" :clearable="
              form_relative_details.relative_designation ? false : true
            " :prepend-icon="
              relative_sister_details.relative_designation != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            " outlined hint="Designation" persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <!-- <v-row dense justify="center" v-if="relative_sister_details != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="form_relative_details.relative_department"
            >*</v-icon
          >
          <v-text-field
            dense
            v-model="relative_sister_details.relative_department"
            name="sister_department"
            :required="form_relative_details.relative_department"
            :rules="
              form_relative_details.relative_department
                ? [(v) => !!v || 'Department is required']
                : []
            "
            :clearable="
              form_relative_details.relative_department ? false : true
            "
            :prepend-icon="
              relative_sister_details.relative_department != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            "
            outlined
            hint="Department"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row> -->

      <v-row dense justify="center" v-if="relative_sister_details">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon
            color="error"
            v-if="form_relative_details.relative_office_address"
            >*</v-icon
          > -->
          <v-textarea dense clear-icon="cancel" v-model.trim="relative_sister_details.relative_office_address"
            :value="relative_sister_details.relative_office_address" name="sister_office_address"
            :required="form_relative_details.relative_office_address" hint="Office Address" persistent-hint single-line
            outlined :clearable="
              form_relative_details.relative_office_address ? false : true
            " :prepend-icon="
              relative_sister_details.relative_office_address != null
                ? 'mdi-home-circle'
                : 'mdi-home-circle-outline'
            "></v-textarea>
        </v-col>
      </v-row>
      <!-- End of Sister Details --------------------------------------------->

      <v-card v-if="form_siblings_details">
        <v-card-title> Sibling Details </v-card-title>
        <v-card-text>
          <v-col cols="12">
            <v-row v-if="sibling1!=null">
              <input type="hidden" name="sib1_id" :value="sibling1.sib_id" />
              <v-col cols="12" sm="3" md="3">
                <v-text-field prepend-icon="mdi-numeric-1-circle-outline" dense v-model.trim="sibling1.sibling_name"
                  name="sib1_name" outlined hint="Name" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field dense v-model.trim="sibling1.name_of_school" name="sib1_school_name" outlined
                  hint="School Name" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3" v-if="tenant=='uwws'">
                <v-text-field dense type="number" v-model.trim="sibling1.age" name="sib1_age" outlined hint="Age"
                  persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                <v-text-field dense v-model.trim="sibling1.date_of_birth" name="sib1_dob" outlined hint="DOB DD/MM/YYYY"
                  persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                <v-autocomplete dense v-model="sibling1.relationtype" :items="relationtype_list" name="sib1_relation"
                  single-line outlined hint="Relationship with the child" persistent-hint></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                <v-autocomplete dense v-model="sibling1.standard" :items="standard_list" name="sib1_standard"
                  single-line outlined hint="Grade" persistent-hint></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="sibling1!=null">
              <v-col cols="12" sm="2" md="2" v-if="tenant=='zeal'">
                <v-autocomplete prepend-icon="mdi-numeric-1-circle-outline" dense v-model="sibling1.shift"
                  :items="shift_list" name="sib1_shift" single-line outlined hint="Shift"
                  persistent-hint></v-autocomplete>
              </v-col>
            </v-row>
            <hr>
            <v-row v-if="sibling2!=null">
              <input type="hidden" name="sib2_id" :value="sibling2.sib_id" />
              <v-col cols="12" sm="3" md="3">
                <v-text-field dense v-model.trim="sibling2.sibling_name" name="sib2_name" outlined hint="Name"
                  prepend-icon="mdi-numeric-2-circle-outline" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field dense v-model.trim="sibling2.name_of_school" name="sib2_school_name" outlined
                  hint="School Name" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3" v-if="tenant=='uwws'">
                <v-text-field dense type="number" v-model.trim="sibling2.age" name="sib2_age" outlined hint="Age"
                  persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                <v-text-field dense v-model.trim="sibling2.date_of_birth" name="sib2_dob" outlined hint="DOB DD/MM/YYYY"
                  persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                <v-autocomplete dense v-model="sibling2.relationtype" :items="relationtype_list" name="sib2_relation"
                  single-line outlined hint="Relationship with the child" persistent-hint></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                <v-autocomplete dense v-model="sibling2.standard" :items="standard_list" name="sib2_standard"
                  single-line outlined hint="Grade" persistent-hint></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="sibling2!=null">
              <v-col cols="12" sm="2" md="2" v-if="tenant=='zeal'">
                <v-autocomplete prepend-icon="mdi-numeric-2-circle-outline" dense v-model="sibling2.shift"
                  :items="shift_list" name="sib2_shift" single-line outlined hint="Shift"
                  persistent-hint></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
      </v-card>


      <v-row justify="center" dense>
        <v-col cols="10" sm="10" md="10"> </v-col>
      </v-row>

      <v-row justify="center" dense>
        <v-col cols="10" sm="10" md="10">
          <div style="text-align: center">
            <v-btn class="mt-2" :color="isValid ? 'primary darken-1' : 'grey lighten-1'" @click="submit"
              :disabled="!isValid">Save</v-btn>
          </div>
        </v-col></v-row>
    </v-form>
  </div>
</template>
<script>
  import axios from "axios";
  export default {
    data() {
      return {
        idTypeFather: 'aadhar',
        idTypeMother: 'aadhar',
        isValid: true,
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        application_form_data: {
          admission_form_no: "",
          admission_form_id: "",
        },
        relative_father_details: null,
        relative_mother_details: null,
        relative_brother_details: null,
        relative_sister_details: null,
        form_relative_details: null,
        occupation_list: null,
        state_list: null, cities_list: null,
        form_who_takes_pupil_studies: null,
        who_takes_pupil_studies: null,
        sibling1: null,
        sibling2: null,
        form_siblings_details: null,
        relationtype_list: ['Brother', 'Sister'],
        standard_list: [], shift_list: [],
        tenant: 'wws',
        show_single_parent_checkbox: false,
        isSingleMother: false,
        isSingleFather: false,
        father_name_local_lang: {
          field_value: ""
        },
        mother_name_local_lang: {
          field_value: ""
        },
        father_education_qualification: {
          field_value: ""
        },
        mother_education_qualification: {
          field_value: ""
        },

        rules: {
          mobile: (value) => {
            const pattern = /^[0-9]{10}$/;
            return !value || pattern.test(value) || "Mobile number must be 10 digits";
          }
        },
      };
    },
    created() {
      this.tenant = localStorage.getItem("EPS-tenant");
    },
    methods: {
      async convertToUnicode(text, targetField){

        if(!targetField) return

        var value = text ? text : ''

        if(!value){
          targetField.field_value = ''
          return
        }

        const res = await fetch(
          "https://inputtools.google.com/request?text=" +
          encodeURIComponent(value) +
          "&itc=mr-t-i0-und&num=1"
        )

        const data = await res.json()

        if(data[0] === "SUCCESS"){
          targetField.field_value = data[1][0][1][0]
        }

      },
      toggleParent(parent) {
        if (parent === 'father') {
          this.isSingleMother = this.isSingleFather ? false : this.isSingleMother;
        } else if (parent === 'mother') {
          this.isSingleFather = this.isSingleMother ? false : this.isSingleFather;
        }
      },
      // submit: function (e) {
      //   this.loader = false;
      //   var form = document.getElementById("familydetails_form");
      //   var formData = new FormData(form);

      //   formData.set(
      //     "father_occupation",
      //     this.relative_father_details.relative_occupation.field_value
      //   );
      //   formData.set(
      //     "mother_occupation",
      //     this.relative_mother_details.relative_occupation.field_value
      //   );

      //   if (this.isSingleFather || this.isSingleMother) {
      //     formData.append("issinglefather", this.isSingleFather ? true : false);
      //     formData.append("issinglemother", this.isSingleMother ? true : false);
      //   }
      //   axios.post("/admissionForm/saveRelatives", formData).then(
      //     (response) => {
      //       // success callback

      //       if (response.data.form_saved == "YES") {
      //         this.showSnackbar(
      //           "#4caf50",
      //           'Saved Successfully...Click on Next Tab To Continue'
      //         ); // show snackbar on success
      //       }
      //       this.loader = true;
      //       this.$store.commit("setform_progress", response.data.form_progress);
      //       this.getform()
      //     },
      //     (response) => {
      //       // error callback
      //       this.loader = true;
      //     }
      //   );
      // },
      submit: function (e) {
        // 1. Grab the form element FIRST, while this.loader is still true
        var form = document.getElementById("familydetails_form");
        var formData = new FormData(form);

        // 2. NOW trigger the loader (which hides the form and shows the spinner)
        this.loader = false;

        // 3. Safely check if father details exist before setting occupation
        if (this.relative_father_details && this.relative_father_details.relative_occupation) {
          formData.set(
            "father_occupation",
            this.relative_father_details.relative_occupation.field_value
          );
        }

        // 4. Safely check if mother details exist before setting occupation
        if (this.relative_mother_details && this.relative_mother_details.relative_occupation) {
          formData.set(
            "mother_occupation",
            this.relative_mother_details.relative_occupation.field_value
          );
        }

        if (this.isSingleFather || this.isSingleMother) {
          formData.append("issinglefather", this.isSingleFather ? true : false);
          formData.append("issinglemother", this.isSingleMother ? true : false);
        }

        axios.post("/admissionForm/saveRelatives", formData).then(
          (response) => {
            // success callback
            if (response.data.form_saved == "YES") {
              this.showSnackbar(
                "#4caf50",
                'Saved Successfully...Click on Next Tab To Continue'
              ); 
            }
            // Restore the form and update progress
            this.loader = true;
            this.$store.commit("setform_progress", response.data.form_progress);
            this.getform();
          },
          (error) => {
            // error callback
            console.log(error);
            this.loader = true; // Make sure the form comes back even if the API fails
            this.showSnackbar("#f44336", "An error occurred while saving.");
          }
        );
      },
      getform() {
        axios
          .post("/admissionForm/relatives", this.application_form_data)
          .then((res) => {
            if (res.data.msg == "200") {
              this.relative_father_details = res.data.relative_father_details;
              this.relative_mother_details = res.data.relative_mother_details;
              this.relative_brother_details = res.data.relative_brother_details;
              this.relative_sister_details = res.data.relative_sister_details;
              this.form_relative_details = res.data.form_relative_details;
              this.occupation_list = res.data.occupation_list;
              this.nationality_list = res.data.nationality_list;
              this.form_who_takes_pupil_studies = res.data.form_who_takes_pupil_studies;
              this.who_takes_pupil_studies = res.data.who_takes_pupil_studies;
              this.form_siblings_details = res.data.form_siblings_details;
              this.sibling1 = res.data.sibling1;
              this.sibling2 = res.data.sibling2;
              this.standard_list = res.data.standard_list;
                this.shift_list = res.data.shift_list;
                this.father_name_local_lang = res.data.father_name_local_lang;
                this.mother_name_local_lang = res.data.mother_name_local_lang;
                this.father_education_qualification = res.data.father_education_qualification;
                this.mother_education_qualification = res.data.mother_education_qualification;
                //this.relationtype_list = res.data.relationtype_list
                this.loader = true;
              //by mayur
              this.state_list = res.data.states_list;
              this.cities_list = res.data.cities_list;
              this.show_single_parent_checkbox = res.data.show_single_parent_checkbox;
              //by mayur

              this.$store.commit("setform_progress", res.data.form_progress);
            }
          })
          .catch((error) => {
            this.loader = true;
            window.console.log(error);
          });
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
    },
    mounted() {
      this.application_form_data = this.$store.getters.application_form_data;
      this.getform();
    },
    watch: {
      isSingleFather(newVal) {
        if (newVal) {
          this.isSingleMother = false;
          this.relative_mother_details = {
            ...this.relative_father_details,
            field_display_name: "Mother Details"
          };
        }
      },
      isSingleMother(newVal) {
        if (newVal) {
          this.isSingleFather = false;
          this.relative_father_details = {
            ...this.relative_mother_details,
            field_display_name: "Father's Details"
          };
        }
      }
    }
  };
</script>